import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FormControl, Modal } from '@mui/material';
import styled from 'styled-components';
import { colors, fontSize, fontWeight } from '../../../theme';
import { ButtonStyled } from '../../../theme/style';

interface ActionButtonStyledProps {
    default?: boolean
}

export const CloseIconModalStyled = styled(CloseIcon)`
    && {
        position: absolute;
        right: 16px;
        top: 16px;
        cursor: pointer;
        padding: 8px;
        transition: color 400ms ease-in-out;
        &:hover {
            color: ${colors.grey100};
            transition: color 400ms ease-in-out;
        }
    }
`;

export const ModalStyled = styled(Modal)`
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
`;

export const ActionButtonContainer = styled.div`
    display: flex;
    gap: 16px;
    margin-top: 15px;
`;

export const ActionButtonStyled = styled(ButtonStyled)((props : ActionButtonStyledProps) => `
    && {
        padding: 12px;
        background-color: ${props.default ? colors.default : colors.grey000};
        color: ${props.default ? colors.grey000 : colors.default};
        font-weight: ${fontWeight.bold};
        max-height: 48px;
        &:hover {
            background-color: ${props.default ? colors.defaultHover : colors.grey700};
        }
        &:disabled {
            background-color: ${colors.grey600};
            color: ${colors.grey300};
        }
        width: 50%;
    }
`);

export const DeleteButtonStyled = styled(ButtonStyled)`
    && {
        padding: 12px;
        font-size: ${fontSize.sm};
        background-color: transparent;
        color: ${colors.grey200};
        font-weight: ${fontWeight.regular};
        max-height: 48px;
        &:hover {
            background-color: transparent;
        }
        &:disabled {
            background-color: ${colors.grey600};
            color: ${colors.grey200};
        }
        margin-top: 15px;
        gap: 10px;
        align-items: center;
    }
`;

export const FormControlStyled = styled(FormControl)`
    && { width: 100%;
    max-height: 70vh;
    overflow-y: none;
    padding-right: 12px;
    background-color: ${colors.grey800};
    margin-top: 25px;
}
`;

export const ColorSwatchBoxStyled = styled.div`
    && {
    display: flex;
    flex-direction: row;
    padding: 10px 8px;
    align-items: center;
    background-color: ${colors.grey000};
    border-radius: 4px;
    margin: 7px 0px;
    cursor: pointer;
    justify-content: space-between;
    &:hover {
        background-color: ${colors.grey700};
    }
}
`;

export const ColorContainerStyled = styled.div`
    && {
    display: flex;
    flex-direction: row;
    gap: 10px;
}
`;

export const EditColorIconStyled = styled(EditOutlinedIcon)`
&& {
    padding: 0 8px;
    color: ${colors.grey500};
    transition: color 400ms ease-in-out;
    cursor: pointer;
    &:hover {
        color: ${colors.black000};
        transition: color 400ms ease-in-out;
    }
}
`;

export const DeleteIconStyled = styled(DeleteOutlineOutlinedIcon)`
    && {
        cursor: pointer;
        transition: color 400ms ease-in-out;
        color: ${colors.grey200};
        padding: 0;
        width: 20px;
        &:hover {
            color: ${colors.grey200};
            background: transparent;
            transition: color 400ms ease-in-out;
        }
    }
`;
